import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const employeeTransactionLocaleModule: LocaleModule = {
  name: "employeeTransaction",
  messages: { en: en, it: it },
};
